import { RSAA } from 'redux-api-middleware';
import type { RSAACallRequest, RSAACallAction } from '@makemydeal/dr-react-18-wrappers';
import { locHrefUtil, apiConfigHelper, getDocumentReferrer } from '@makemydeal/dr-shared-ui-utils';

import { Actions } from '@makemydeal/dr-sales-checkin-store';

/**
 * @param meta Optional meta attached to each request/success/failure action. Pass
 *   `{ skipGlobalSpinner: true }` for background polling (e.g. dealRefId polling) so
 *   loaderMiddleware skips the full-page loader and no UI is surfaced (DE754115).
 */
export const fetchDeal = (appPrefix: string, dealXgId: string, meta?: Record<string, any>) => {
    const locHref = locHrefUtil.getLocHref();

    const bffApiUrlResult = apiConfigHelper.buildBffApiUrl(appPrefix, locHref, 'deals');
    const endpoint = bffApiUrlResult.url;

    const referrer = getDocumentReferrer();

    const request: RSAACallRequest = {
        endpoint: `${endpoint}/${dealXgId}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'x-dr-referrer': referrer
        },
        types: [
            { type: Actions.FETCH_DEAL_REQUEST, meta },
            { type: Actions.FETCH_DEAL_SUCCESS, meta },
            { type: Actions.FETCH_DEAL_FAILURE, meta }
        ]
    };
    return {
        [RSAA]: request
    } as RSAACallAction;
};
